import {IconProps} from "./types";

export const MagicIcon = ({stroke}: IconProps) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.33337 6.66634L3.33337 12.6663M11.3334 4.66634L12.6667 3.33301M7.33337 4.66634L6.00004 3.33301M12.6667 9.99967L11.3334 8.66634M9.33337 3.99967V3.33301M9.33337 10.6663V9.99967M12 6.66634H12.6667M5.33337 6.66634H6.00004"
        stroke={stroke || "#6B7280"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
